// extracted by mini-css-extract-plugin
module.exports = {"error-text":"template_editor__error-text___VPXaX","errorText":"template_editor__error-text___VPXaX"};